import { defineComponent as _defineComponent } from 'vue'
import { isEmpty, omit } from '@/utils/misc';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import HealthBar from '@/components/careConsole/HealthBar.vue';
import { CareOverviewHealthData } from '@/models/Charts/chartsData';
import { dateRangeToDateStrings } from '@/utils/dates';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HealthIndicators',
  props: {
    dateRange: null,
    deviceId: null
  },
  setup(__props: any) {

const props = __props as {
  dateRange: [Date, Date];
  deviceId: string;
};



const { t } = useI18n();

function getLevelMaximums(healthEntry: CareOverviewHealthData[]): number[] {
  return Object.values(omit(healthEntry, ['deviceElement', 'value']));
}

const widgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareOverviewHealthIndicators,
      props.deviceId,
      dateRangeString.value,
    ),
);

const dateRangeString = computed<[string, string]>(() =>
  dateRangeToDateStrings(props.dateRange),
);

return { __sfc: true,props, t, getLevelMaximums, widgetDefinition, dateRangeString, isEmpty, WidgetContainer, HealthBar }
}

})